import { gql } from "@apollo/client";

export const LIST_LINKING_ID = gql`
  query LinkingDefinitions($page: Int = 1, $limit: Int = 20 $exclude: [LinkingDefinitionType!] = []) {
    LinkingIDDefinitionList(params: {page: $page, limit: $limit}) {
      entries {
        id slug name LinkingIDs(excludeLinkedTypes: $exclude) {
          linking_id value
        }
      }
    }
  }
`;

export const CREATE_AND_LINK_ID = gql`
  mutation CreateAndLinkToObject($value: String! $definitionId: String! $linkingType: LinkingDefinitionType! $objectId: String!) {
    CreateAndLinkIdToObject(value: $value definitionId: $definitionId linkingType: $linkingType objectId: $objectId)
  }
`;
export const CREATE_LINKING_ID = gql`
  mutation CreateLinkingID($value: String! $definitionId: String!) {
    CreateLinkingID(value: $value definitionId: $definitionId)
  }
`;

export const DELETE_LINKING_ID = gql`
  mutation DeleteLinkingID($id: ID!) {
    DeleteLinkingID(id: $id)
  }
`;

export const LINK_OBJECT_TO_LINKING_ID = gql`
  mutation LinkID($objectId: String! $linkingId: String! $linkType: LinkingDefinitionType!) {
    LinkObjectToLinkingID(objectId: $objectId linkingId: $linkingId linkType: $linkType )
  }
`;

export const UNLINK_OBJECT_FROM_ID = gql`
  mutation UnlinkObjectFromID($linkingId: String! $objectId: String!) {
    UnlinkObjectFromLinkingID(linkingId: $linkingId objectId: $objectId)
  }
`;

export const CREATE_ID_DEFINITION = gql`
  mutation CreateIDDefinition($slug: String $name: String! $description: String) {
    CreateLinkingIDDefinition(slug: $slug name: $name description: $description)
  }
`;

export const UPDATE_ID_DEFINITION = gql`
  mutation UpdateIDDefinition($id: ID! $slug: String $description: String $name: String!) {
    UpdateLinkingIDDefinition(id: $id description: $description name: $name slug: $slug) {
      id name description slug
    }
  }
`;

export const DELETE_ID_DEFINITION = gql`
  mutation DeleteIDDefinition($id: ID!) {
    DeleteLinkingIDDefinition(id: $id)
  }
`;

export const VIEW_ID_DEFINITION = gql`
  query ViewDefinition($id: ID!) {
    LinkingIDDefinition(id: $id ) {
      name description id slug LinkingIDs {
        linking_id value
      }
    }
  }
`;
